export default "/images/card-image.svg?f775f84591a82685be8363d9575c4940";